import { Col, Row } from "antd";
import { get, isEmpty, set } from "lodash";
import { useTranslation } from "react-i18next";
import {
  MdAdminPanelSettings,
  MdOutlineFreeCancellation,
  MdWorkOutline,
} from "react-icons/md";
import Form from "shared/components/Form";
import Input from "shared/components/Input";
import Select from "shared/components/Select";
import { NAME_SPACES } from "shared/locales/constants";
import {
  PROFESSIONAL_SITUATIONS,
  PROFILE_LIST,
  SITUATION_PROFESSIONAL,
  SUBSCRIPTION_FORM_KEYS,
} from "utils/constants";

const MUTUAL_MOBILITY_SITUATION_PROFESSIONAL = {
  [SITUATION_PROFESSIONAL.SALARIED]: SITUATION_PROFESSIONAL.SALARIED,
  [SITUATION_PROFESSIONAL.STUDENT]: SITUATION_PROFESSIONAL.STUDENT,
  [SITUATION_PROFESSIONAL.RETIRED]: SITUATION_PROFESSIONAL.RETIRED,
  [SITUATION_PROFESSIONAL.SEARCHING_FOR_A_JOB]:
    SITUATION_PROFESSIONAL.SEARCHING_FOR_A_JOB,
};
const Activity = ({
  formProps,
  setPercent,
  setFieldValue,
  disabled,
  setDisabled,
  isFieldRequired,
  initialValues,
  errors,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.CONTRACT);
  const SUBSCRIPTION = t("SUBSCRIPTION", { returnObjects: true });
  const ACTIVITY = t("SUBSCRIPTION.FORM.ADDITIONAL_INFORMATION.ACTIVITY", {
    returnObjects: true,
  });
  const isTns = get(initialValues, "insurancePlan.fields.tns");
  return (
    <div
      className="subscription-form--wrapper"
      id={`${SUBSCRIPTION_FORM_KEYS.ADDITIONAL_INFORMATION.ACTIVITY}-section`}
    >
      <Form type="vertical" title={ACTIVITY.TITLE}>
        <Row gutter={[16, 16]}>
          <Col lg={24} xs={24}>
            <Input
              label={SUBSCRIPTION.FORM.PROFILE.LABEL}
              icon={<MdAdminPanelSettings size={16} />}
              defaultValue={
                SUBSCRIPTION.FORM.PROFILE.OPTIONS[
                  get(initialValues, "project.contact.fields.profile")
                ]
              }
              required={isFieldRequired("project.contact.fields.profile")}
              disabled={true}
            />
          </Col>
          {get(initialValues, "project.contact.fields.profile") ===
          PROFILE_LIST.RENAULT_EMPLOYEE ? (
            <>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={ACTIVITY.MATRICULATION.PLACEHOLDER}
                  label={ACTIVITY.MATRICULATION.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.fields.matriculation",
                  )}
                  errors={errors["project.contact.fields.matriculation"]}
                  touched={
                    !isEmpty(errors["project.contact.fields.matriculation"])
                  }
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(
                      initialValues,
                      "project.contact.fields.matriculation",
                      value,
                    );
                  }}
                  required={isFieldRequired(
                    "project.contact.fields.matriculation",
                  )}
                />
              </Col>
              <Col lg={24} xs={24}>
                <Select
                  options={(() =>
                    Object.entries(PROFESSIONAL_SITUATIONS).map(
                      ([key, value]) => ({
                        value,
                        label: ACTIVITY.SITUATION.OPTIONS[key],
                      }),
                    ))()}
                  label={ACTIVITY.SITUATION.LABEL}
                  icon={<MdWorkOutline size={16} />}
                  placeholder={ACTIVITY.SITUATION.PLACEHOLDER}
                  defaultValue={get(
                    initialValues,
                    "project.contact.socioProfessionalCategory",
                  )}
                  errors={errors["project.contact.socioProfessionalCategory"]}
                  touched={
                    !isEmpty(
                      errors["project.contact.socioProfessionalCategory"],
                    )
                  }
                  onChange={(value) => {
                    set(
                      initialValues,
                      "project.contact.socioProfessionalCategory",
                      value,
                    );
                  }}
                  onBlur={() => setPercent(initialValues)}
                  required={isFieldRequired(
                    "project.contact.socioProfessionalCategory",
                  )}
                />
              </Col>
            </>
          ) : (
            <Col lg={24} xs={24}>
              <Select
                options={(() =>
                  Object.entries(MUTUAL_MOBILITY_SITUATION_PROFESSIONAL).map(
                    ([key, value]) => ({
                      value,
                      label: ACTIVITY.SITUATION.MUTUAL_MOBILITY_OPTIONS[key],
                    }),
                  ))()}
                label={ACTIVITY.SITUATION_PROFESSIONAL.LABEL}
                icon={<MdWorkOutline size={16} />}
                placeholder={ACTIVITY.SITUATION_PROFESSIONAL.PLACEHOLDER}
                defaultValue={get(
                  initialValues,
                  "project.contact.socioProfessionalCategory",
                )}
                errors={errors["project.contact.socioProfessionalCategory"]}
                touched={
                  !isEmpty(errors["project.contact.socioProfessionalCategory"])
                }
                onChange={(value) => {
                  set(
                    initialValues,
                    "project.contact.socioProfessionalCategory",
                    value,
                  );
                  setPercent(initialValues);
                }}
                onBlur={() => setPercent(initialValues)}
                required={isFieldRequired(
                  "project.contact.socioProfessionalCategory",
                )}
              />
            </Col>
          )}

          {isTns && (
            <>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={ACTIVITY.SOCIAL_REASON.PLACEHOLDER}
                  label={ACTIVITY.SOCIAL_REASON.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.fields.socialReason",
                  )}
                  errors={errors["project.contact.fields.socialReason"]}
                  touched={
                    !isEmpty(errors["project.contact.fields.socialReason"])
                  }
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(
                      initialValues,
                      "project.contact.fields.socialReason",
                      value,
                    );
                  }}
                  required={isFieldRequired(
                    "project.contact.fields.socialReason",
                  )}
                />
              </Col>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={ACTIVITY.SIRET.PLACEHOLDER}
                  label={ACTIVITY.SIRET.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.siretNumber",
                  )}
                  errors={errors["project.contact.siretNumber"]}
                  touched={!isEmpty(errors["project.contact.siretNumber"])}
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(initialValues, "project.contact.siretNumber", value);
                  }}
                  required={isFieldRequired("project.contact.siretNumber")}
                />
              </Col>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={ACTIVITY.NAF_CODE.PLACEHOLDER}
                  label={ACTIVITY.NAF_CODE.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.fields.nafCode",
                  )}
                  errors={errors["project.contact.fields.nafCode"]}
                  touched={!isEmpty(errors["project.contact.fields.nafCode"])}
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(initialValues, "project.contact.fields.nafCode", value);
                  }}
                  required={isFieldRequired("project.contact.fields.nafCode")}
                />
              </Col>
              <Col lg={24} xs={24}>
                <Input
                  placeholder={ACTIVITY.ORGANIZATION_NUMBER.PLACEHOLDER}
                  label={ACTIVITY.ORGANIZATION_NUMBER.LABEL}
                  icon={<MdOutlineFreeCancellation size={16} />}
                  defaultValue={get(
                    initialValues,
                    "project.contact.fields.organizationNumber",
                  )}
                  errors={errors["project.contact.fields.organizationNumber"]}
                  touched={
                    !isEmpty(
                      errors["project.contact.fields.organizationNumber"],
                    )
                  }
                  onBlur={() => setPercent(initialValues)}
                  onChange={({ target: { value } }) => {
                    set(
                      initialValues,
                      "project.contact.fields.organizationNumber",
                      value,
                    );
                  }}
                  required={isFieldRequired(
                    "project.contact.fields.organizationNumber",
                  )}
                />
              </Col>
            </>
          )}
        </Row>
      </Form>
    </div>
  );
};

export default Activity;
